// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"zCDtjEN1RzbIScPAwIoSG","display":"_1TNCZF5_TCfki68GFOGRM1","spinnerLifeInsurance":"_1KDDt1WDYOQ3knqqEEVZmN","spin":"_3uprxlJ-yuDCq-rFqWa2ck"};